<template>
  <div class="search position-relative mt-3 mt-lg-5">
    <div class="background-lb form-wrap px-3 pb-3 rounded">
      <div class="py-1">מילת חיפוש</div>
      <b-form-group class="mb-0 bg-white input-wrap rounded"> 
        <b-form-input      
          v-model="searchWord"
          id="search-input"
          ref="searchInput"
          class="d-inline f-narkis w-75 border-0 py-0 rounded"
          @keydown="onKeyDown()"
          @input="onInput"
          @keyup.enter="runSearch()"
        >
        </b-form-input>
        <b-button 
          variant="link"
          @click="runSearch"
          class="border-none shadow-none d-inline bg-white p-2 w-25 text-left"
          >
            <i class="fas fa-search"></i>
        </b-button> 
      </b-form-group>
      <div id="too-many-tokens" class="py-1 mb-n3" v-if="invalidTerm && searchWord.trim() !== ''">{{hebrew ? 'נא להזין מילה אחת בלבד' : 'Please enter one valid Hebrew word'}}</div>
    </div>    
  </div>
</template>

<script>
import {Actions} from '@/store/stateChanges'
import {englishKeyEventToHebrew} from '@/js/englishToHebrew'

export default {
  name: 'SearchForm',
  props: {
  },
  data() {
    return {
      searchWord: '',//'יּוּשַׁב'
    }
  },
  mounted () {
    this.checkSearchParam()
    this.$refs.searchInput.focus()
  },
  methods: {
    onKeyDown () {
      englishKeyEventToHebrew(event, 'search-input')      
    },
    onInput () {
      this.$store.commit('SET_TEXT_FOR_API_CALL',  this.searchWord)
    },
    checkSearchParam () {
      const urlParams = new URLSearchParams(window.location.search)
      let searchParam = urlParams.get('search')
      let modeParam = urlParams.get('mode')
      let numParam = parseInt(urlParams.get('num_words'))
      if (numParam < 2) numParam = 2
      if (numParam > 5) numParam = 5
      if (searchParam) {
        this.searchWord = searchParam
        this.$store.commit('SET_TEXT_FOR_API_CALL', searchParam)
        if(modeParam) this.$store.commit('SET_MODE', modeParam)
        if(numParam) this.$store.commit('SET_NUMBER_OF_WORDS', numParam)
        this.runSearch()
      }
    }, 
    runSearch () {      
      this.$store.commit('SET_TEXT_FOR_API_CALL',  this.searchWord) //in case word was copy pasted
      this.$store.dispatch(Actions.RUN_SEARCH)      
    }
  },
  computed: {  
    hebrew () {
      return this.$settings.hebrew
    },
    invalidTerm () {
      return this.$store.state.invalidTerm
    },
    textForApiCall () {
      return this.$store.state.textForApiCall
    }
  },
  watch: {
    textForApiCall (val) {
      if (val === '') {
        this.searchWord = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .background-lb {
    background-color: #d6ecff!important;
  }
  .rounded {
    border-radius: 4px!important;
  }
  .form-control {
    font-size: 25px;
    height: auto;
    line-height: 34px;
  }
</style>
